import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import { useCallback, useEffect, useMemo } from 'react';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import { useGetLocationByFiasId, useGetLocationSettlement } from 'entities/creditForm';

export const useRegionLocationRouteLoader = () => {
  const { watch, setValue } = useFormContext<TCreditFormCommonFields>();
  const [loadLocationSettlement, { data: settlementData }] = useGetLocationSettlement();
  const [loadLocationByFiasId, { data: locationData }] = useGetLocationByFiasId();
  const region = watch('region');
  const fiasId = useMemo(() => settlementData?.fias, [settlementData?.fias]);

  const getLocationSettlement = useCallback(
    async (address: string) => {
      loadLocationSettlement(address, true);
    },
    [loadLocationSettlement],
  );

  useEffect(() => {
    if (settlementData) {
      setValue('regionLocationRoute', settlementData.route || '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settlementData]);

  useEffect(() => {
    if (region?.value && (region?.data as unknown as { type: 'manual' })?.type !== 'manual') {
      getLocationSettlement(String(region.value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [region?.value]);

  useEffect(() => {
    if (fiasId) {
      loadLocationByFiasId(fiasId, true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fiasId]);

  useEffect(() => {
    if (locationData) {
      setValue('regionLocation', locationData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationData?.fias]);
};
